import React from 'react';
import clsx from 'clsx';

/**
 * Button component for primary/secondary actions.
 * Props:
 * - variant: 'primary' | 'secondary'
 * - fullWidth: boolean
 * - disabled: boolean
 * - leftIcon/rightIcon: ReactNode
 * - children: button label
 * - lockedReason: 'lock' | undefined
 * - ...rest: other button props
 */
const Button = React.forwardRef(({
  variant = 'primary',
  fullWidth = false,
  disabled = false,
  leftIcon,
  rightIcon,
  className = '',
  children,
  lockedReason,
  ...rest
}, ref) => {
  // Inline SVG for lock
  const LockIcon = (
    <svg className="w-4 h-4 mr-1 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="8" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
  );
  return (
    <button
      ref={ref}
      type="button"
      className={clsx(
        'btn',
        variant === 'primary' && 'btn-primary',
        variant === 'secondary' && 'btn-secondary',
        fullWidth && 'w-full',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {disabled && lockedReason === 'lock' && LockIcon}
      {leftIcon && <span className="mr-2 flex items-center">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="ml-2 flex items-center">{rightIcon}</span>}
    </button>
  );
});

Button.displayName = 'Button';

export default Button; 